// extracted by mini-css-extract-plugin
var _1 = "xpGfMcZtv1WBCEHqdiee";
var _2 = "zzul0la7KQjJuUbslOmg";
var _3 = "RB8OeSHG4CJgr49BfuWa";
export { _1 as "small", _2 as "text", _3 as "wrapper" }
